// extracted by mini-css-extract-plugin
export default {"socialLinkList":"c-h_eV"};